// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"0f377048","488":"42ce9a39","584":"688b1141","768":"324c9c06","818":"77c4a177"}[chunkId] + ".chunk.js";
};